import { render } from "./lab_setting.vue?vue&type=template&id=c9c4b0b4&scoped=true"
import script from "./lab_setting.vue?vue&type=script&lang=js"
export * from "./lab_setting.vue?vue&type=script&lang=js"

import "./lab_setting.vue?vue&type=style&index=0&id=c9c4b0b4&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9c4b0b4"]])

export default __exports__